import { getMessage } from '../../../../lib/translator'

export const PICKING_ORDER_STATUSES = [
  'PENDING_PICKING',
  'PICKING',
  'PENDING_SHIPMENT',
  'SHIPPED',
  'DELIVERED',
  'COMPLETED',
  'CANCELLED',
  'RETURNED',
]

export const getPickingOrderStatusOptions = () =>
  PICKING_ORDER_STATUSES.map((status) => ({
    text: getMessage(`picking.orderDetail.status.${status}`),
    value: status,
  }))

export const getPickingOrderStatusLabel = (status) => {
  if (!status) {
    return ''
  }
  return getMessage(`picking.orderDetail.status.${status}`)
}

export const getPickingOrderStatusClassName = (status) => {
  if (!status) {
    return 'picking-order-status'
  }
  return `picking-order-status picking-order-status--${String(status)
    .toLowerCase()
    .replace(/-/g, '_')}`
}

const PICKING_TO_DELIVERY_ORDER_STATUS = {
  PENDING_PICKING: 'DELIVERY_ORDER_STATUS_PENDING',
  PICKING: 'DELIVERY_ORDER_STATUS_PICKING',
  PENDING_SHIPMENT: 'DELIVERY_ORDER_STATUS_PACKED',
  SHIPPED: 'DELIVERY_ORDER_STATUS_DISPATCHED',
  DELIVERED: 'DELIVERY_ORDER_STATUS_COMPLETED',
  COMPLETED: 'DELIVERY_ORDER_STATUS_COMPLETED',
  CANCELLED: 'DELIVERY_ORDER_STATUS_CANCELLED',
  RETURNED: 'DELIVERY_ORDER_STATUS_RETURNED',
}

export const mapPickingStatusToDeliveryOrderStatus = (status) =>
  PICKING_TO_DELIVERY_ORDER_STATUS[status] || 'DELIVERY_ORDER_STATUS_PROCESSING'
